import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AppBar, Box, Button, Container, Stack } from '@mui/material';
import { Slideshow } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import { isAdminEmail } from '../services/admin';

function Header() {
    const location = useLocation();
    const { currentUser } = useAuth();
    const isActive = (path) => location.pathname === path || location.pathname.startsWith(`${path}/`);
    const navItems = [
        { label: 'Home', path: '/' },
        { label: 'Courses', path: '/lesson' },
        { label: 'Profile', path: '/profile' },
        ...(isAdminEmail(currentUser?.email) ? [{ label: 'Test', path: '/test' }, { label: 'Admin', path: '/admin' }] : []),
    ];

    return (
        <AppBar position="sticky">
            <Container maxWidth="xl">
                <Box
                    sx={{
                        height: 64,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 2,
                    }}
                >
                    <Box
                        component={Link}
                        to="/"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            textDecoration: 'none',
                        }}
                    >
                        <Box
                            component="img"
                            src="/nixdojo-logo.svg"
                            alt="NixDojo"
                            sx={{
                                display: 'block',
                                width: { xs: 132, sm: 156 },
                                height: 'auto',
                            }}
                        />
                    </Box>

                    <Stack direction="row" spacing={1} alignItems="center">
                        {navItems.map(({ label, path }) => (
                            <Button
                                key={label}
                                component={Link}
                                to={path}
                                sx={{
                                    color: isActive(path) ? 'text.primary' : 'text.secondary',
                                    backgroundColor: isActive(path) ? 'grey.100' : 'transparent',
                                    minWidth: 0,
                                    '&:hover': {
                                        color: 'text.primary',
                                        backgroundColor: 'grey.100',
                                    },
                                }}
                            >
                                {label}
                            </Button>
                        ))}
                        {isAdminEmail(currentUser?.email) && (
                            <Button
                                component={Link}
                                to="/presentation"
                                variant={isActive('/presentation') ? 'contained' : 'outlined'}
                                startIcon={<Slideshow />}
                                aria-label="Presentation mode"
                                sx={{ px: { xs: 1.25, sm: 2.25 }, '& .MuiButton-startIcon': { mr: { xs: 0, sm: 1 } } }}
                            >
                                <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Present</Box>
                            </Button>
                        )}
                        <Button
                            component={Link}
                            to={currentUser ? '/profile' : '/login'}
                            variant="contained"
                            color="primary"
                        >
                            {currentUser ? 'Account' : 'Log in'}
                        </Button>
                    </Stack>
                </Box>
            </Container>
        </AppBar>
    );
}

export default Header;
